import type { QueryClient } from '@tanstack/react-query'
import { queryClient as appQueryClient } from './queryClient'
import { clearFirstAccessDismissal } from './firstAccessDismissal'

/** Cache do service worker para `/api/v1/*` (regra NetworkFirst do `vite.config.ts`). */
export const API_SW_CACHE = 'api-cache'

/**
 * Fim de sessao (logout ou refresh recusado): nada do usuario anterior pode ser servido ao
 * proximo login na mesma aba — nem o cache do React Query (staleTime de 5 min serviria a
 * transcricao de outra pessoa sem pedir ao servidor) nem as respostas guardadas pelo SW.
 */
export async function clearSessionData(client: QueryClient = appQueryClient): Promise<void> {
  client.clear()
  // MH14-04b: o proximo login na mesma aba volta a ver os videos obrigatorios.
  clearFirstAccessDismissal()
  try {
    if (typeof caches !== 'undefined') await caches.delete(API_SW_CACHE)
  } catch {
    // Cache Storage indisponivel (aba privada, contexto inseguro): nao ha o que limpar
  }
}
